
import { css } from 'lit';
export default css`
:host {

  display: block;
}

.heading {

  margin-bottom: 0px;

  font-family: adobe-caslon-pro, Adobe Caslon Pro, EB Garamond, serif;

  font-weight: 700;

  line-height: 1.1;
}

.heading.text-purple {

  font-family: Lato, sans-serif;
}

.heading.text-purple {

  --tw-text-opacity: 1;

  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.heading.text-purple {

    margin-bottom: 30px;
  }

.style--cta-image {

  font-size: 2.5rem;
}

.style--cta-image {

  letter-spacing: -0.0625rem;
}

@media (min-width: 1024px) {

  .style--cta-image {

    font-size: 2.8125rem;
  }
}

@media (min-width: 1024px) {

  .style--cta-image {

    letter-spacing: -0.0425rem;
  }
}

.style--heading1 {

  font-size: 2.5rem;
}

.style--heading1 {

  letter-spacing: -0.0625rem;
}

@media (min-width: 1024px) {

  .style--heading1 {

    font-size: 2.8125rem;
  }
}

@media (min-width: 1024px) {

  .style--heading1 {

    letter-spacing: -0.0425rem;
  }
}

.style--heading1 {
    line-height: 1.1;
  }

.style--heading2 {

  font-size: 1.875rem;
}

.style--heading2 {

  letter-spacing: -0.03125rem;
}

@media (min-width: 1024px) {

  .style--heading2 {

    font-size: 2.5rem;
  }
}

.style--heading2 {
    line-height: 1.2;
  }

.style--heading3 {

  font-size: 1.5rem;
}

.style--heading3 {

  line-height: 1.1;
}

.style--heading3 {

  letter-spacing: -0.03125rem;
}

@media (min-width: 1024px) {

  .style--heading3 {

    font-size: 1.75rem;
  }
}

@media (min-width: 1024px) {

  .style--heading3 {

    line-height: 1.15;
  }
}

.style--heading3 {
    line-height: 1.15;
  }

.style--heading4 {

  font-family: Lato, sans-serif;
}

.style--heading4 {

  font-size: 1.5rem;
}

.style--heading4 {

  line-height: 1.2;
}

.style--heading4 {

  letter-spacing: -0.0425rem;
}

@media (min-width: 1024px) {

  .style--heading4 {

    font-size: 1.625rem;
  }
}

.style--heading4 {
    line-height: 1.2;
  }

.style--heading5 {

  font-size: 1.375rem;
}

.style--heading5 {

  line-height: 1.15;
}

.style--heading5 {

  letter-spacing: -0.0625rem;
}

@media (min-width: 1024px) {

  .style--heading5 {

    letter-spacing: -0.046875rem;
  }
}

.style--heading5 {
    line-height: 1.15;
  }

.style--location-card-list {

  margin-bottom: 1rem;
}

.style--location-card-list {

  font-family: adobe-caslon-pro, Adobe Caslon Pro, EB Garamond, serif;
}

.style--location-card-list {

  font-size: 1.5rem;
}

.style--location-card-list {

  line-height: 1.15;
}

.style--location-card-list {

  letter-spacing: -0.0625rem;
}

@media (min-width: 1024px) {

  .style--location-card-list {

    margin-bottom: 0px;
  }
}

@media (min-width: 1024px) {

  .style--location-card-list {

    letter-spacing: -0.046875rem;
  }
}

.style--location-card-list {
    font-size: 24px;
  }

@media (min-width: 1024px) {

.style--location-card-list {
      font-size: 22px
  }
    }

.style--location-card-map {

  margin-bottom: 1rem;
}

.style--location-card-map {

  font-family: adobe-caslon-pro, Adobe Caslon Pro, EB Garamond, serif;
}

.style--location-card-map {

  font-size: 1.5rem;
}

.style--location-card-map {

  line-height: 1.15;
}

.style--location-card-map {

  letter-spacing: -0.0625rem;
}

.style--location-card-map {

  --tw-text-opacity: 1;

  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

@media (min-width: 1024px) {

  .style--location-card-map {

    margin-bottom: 0px;
  }
}

@media (min-width: 1024px) {

  .style--location-card-map {

    letter-spacing: -0.046875rem;
  }
}

.style--location-card-map {
    font-size: 22px;
    line-height: 34px;
  }

.style--location-card-map:hover {

  --tw-text-opacity: 1;

  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

.style--location-heading {

  font-family: Lato, sans-serif;
}

.style--location-heading {

  font-size: 0.9375rem;
}

.style--location-heading {

  font-weight: 900;
}

.style--location-heading {

  text-transform: uppercase;
}

.style--location-heading {

  line-height: 1.15;
}

.style--location-heading {

  letter-spacing: 0.0625rem;
}

.style--location-heading {

  --tw-text-opacity: 1;

  color: rgba(67, 75, 90, var(--tw-text-opacity));
}

@media (min-width: 1024px) {

  .style--location-heading {

    margin-bottom: 1rem;
  }
}

@media (min-width: 1024px) {

  .style--location-heading {

    font-family: Lato, sans-serif;
  }
}

@media (min-width: 1024px) {

  .style--location-heading {

    font-size: 1.25rem;
  }
}

@media (min-width: 1024px) {

  .style--location-heading {

    font-size: 1rem;
  }
}

@media (min-width: 1024px) {

  .style--location-heading {

    font-weight: 700;
  }
}

@media (min-width: 1024px) {

  .style--location-heading {

    line-height: 1.15;
  }
}

@media (min-width: 1024px) {

  .style--location-heading {

    letter-spacing: 0.125rem;
  }
}

@media (min-width: 1024px) {

  .style--location-heading {

    letter-spacing: 0.0625rem;
  }
}

@media (min-width: 1024px) {

  .style--location-heading {

    --tw-text-opacity: 1;

    color: rgba(35, 35, 35, var(--tw-text-opacity));
  }
}

.style--mlp-hero {
    font-size: 30px;
  }

@media (min-width: 1024px) {

.style--mlp-hero {
      font-size: 40px
  }
    }

.style--image-placemat-cta {

  font-size: 1.75rem;
}

.style--image-placemat-cta {

  font-weight: 700;
}

.style--image-placemat-cta {

  line-height: 2rem;
}

.style--image-placemat-cta {

  letter-spacing: -0.046875rem;
}

@media (min-width: 768px) {

  .style--image-placemat-cta {

    font-size: 1.75rem;
  }
}

@media (min-width: 1024px) {

  .style--image-placemat-cta {

    font-size: 2.5rem;
  }
}

@media (min-width: 1024px) {

  .style--image-placemat-cta {

    line-height: 2.5rem;
  }
}

.style--cta-card {

  font-family: Lato, sans-serif;
}

.style--cta-card {

  font-size: 1.5rem;
}

.style--cta-card {

  line-height: 1.2;
}

.style--cta-card {

  letter-spacing: -0.0425rem;
}

@media (min-width: 1024px) {

  .style--cta-card {

    font-size: 1.625rem;
  }
}

.style--eyebrow {

  font-family: Lato, sans-serif;
}

.style--eyebrow {

  font-size: 0.9375rem;
}

.style--eyebrow {

  font-weight: 900;
}

.style--eyebrow {

  text-transform: uppercase;
}

.style--eyebrow {

  line-height: 1.15;
}

.style--eyebrow {

  letter-spacing: 0.0625rem;
}

@media (min-width: 1024px) {

  .style--eyebrow {

    letter-spacing: 0.125rem;
  }
}

.style--eyebrow-gray {

  font-family: Lato, sans-serif;
}

.style--eyebrow-gray {

  font-size: 0.9375rem;
}

.style--eyebrow-gray {

  font-weight: 900;
}

.style--eyebrow-gray {

  text-transform: uppercase;
}

.style--eyebrow-gray {

  line-height: 1.15;
}

.style--eyebrow-gray {

  letter-spacing: 0.0625rem;
}

.style--eyebrow-gray {

  --tw-text-opacity: 1;

  color: rgba(67, 75, 90, var(--tw-text-opacity));
}

@media (min-width: 1024px) {

  .style--eyebrow-gray {

    letter-spacing: 0.125rem;
  }
}

.style--eyebrow-small {

  font-family: Lato, sans-serif;
}

.style--eyebrow-small {

  font-weight: 900;
}

.style--eyebrow-small {

  text-transform: uppercase;
}

.style--eyebrow-small {

  line-height: 1.15;
}

.style--eyebrow-small {

  letter-spacing: 0.0625rem;
}

@media (min-width: 1024px) {

  .style--eyebrow-small {

    letter-spacing: 0.125rem;
  }
}

.style--eyebrow-small {
    font-size: 12px;
  }

@media (min-width: 640px) {

.style--eyebrow-small {
      font-size: 13px
  }
    }

.style--label-small {

  font-family: Lato, sans-serif;
}

.style--label-small {

  font-size: 0.75rem;
}

.style--label-small {

  font-weight: 900;
}

.style--label-small {

  text-transform: uppercase;
}

.style--label-small {

  line-height: 1.15;
}

.style--label-small {

  letter-spacing: 0.0625rem;
}

@media (min-width: 1024px) {

  .style--label-small {

    font-size: 0.8125rem;
  }
}
`;